import React from 'react';
import { Link } from 'react-router-dom';
import Department01 from '../../../assets/image/department/side-view-man-taking-notes-ambulance-car.jpg';
import Department02 from '../../../assets/image/department/view-new-york-city-night-time.jpg';
import Department03 from '../../../assets/image/department/portrait-young-woman-using-mobile-phone-while-sitting-cafe_1048944-30787175.jpg';
import Department04 from '../../../assets/image/department/rearview-diverse-people-hugging-each-other_53876-156973.jpg';
import Department05 from '../../../assets/image/department/crop-man-writing-notepad.jpg';
import Department06 from '../../../assets/image/department/usa-army-soldiers-with-flag-background-greeting-card-memorial-day-america-celebration_742418-27414.jpg';
import Department07 from '../../../assets/image/department/businessman-pointing-his-presentation-futuristic-digital-screen_53876-102617.jpg';
import Department08 from '../../../assets/image/department/firefighter-training-readiness-showcasing-firefighters-rigorous-training-scenarios-highlighting-their-commitment-accountability-public-safety_765582-10575.jpg';
import Department09 from '../../../assets/image/department/team-doctors-meeting.jpg';
import Department10 from '../../../assets/image/department/elderly-indian-man-self-isolation-home.jpg';

// import './Departments.css'; // Importing a CSS file for additional styling

function Departments() {
  const departments = [
    {
      title: 'Department of Motor Vehicles',
      description: 'Handles driver’s licenses, vehicle registration, and ID services for residents.',
      image: Department03, // Replace with an appropriate DMV-related image
      link: '/department/dmv',
    },
    {
      title: 'Department of Health and Human Services',
      description: 'Promotes public health and ensures access to essential social services for all citizens.',
      image: Department09,
      link: '/department/health',
    },
    {
      title: 'Department of Education',
      description: 'Empowers young people through educational programs and youth mentorship.',
      image: Department05,
      link: '/department/education',
    },
    {
      title: 'Department of Employment and Workforce Development',
      description: 'Provides resources for employment, skills enhancement, and career development.',
      image: Department03,
      link: '/department/employment',
    },
    {
      title: 'Department of Housing and Community Development',
      description: 'Committed to affordable housing, reducing homelessness, and fostering community development.',
      image: Department02,
      link: '/department/housing',
    },
    {
      title: 'Department of Family and Children Services',
      description: 'Supports families with social services, welfare assistance, and community engagement programs.',
      image: Department04,
      link: '/department/family-services',
    },
    {
      title: 'Department of Public Safety',
      description: 'Ensures community safety through law enforcement, emergency response, and public safety education.',
      image: Department01,
      link: '/department/public-safety',
    },
    {
      title: 'Department of Senior Services',
      description: 'Enhances the quality of life for seniors with tailored programs and support.',
      image: Department10,
      link: '/department/senior-services',
    },
    {
      title: 'Department of Veterans Affairs',
      description: 'Provides healthcare, housing, and employment resources for veterans.',
      image: Department06,
      link: '/department/veterans',
    },
    {
      title: 'Department of Emergency Management',
      description: 'Coordinates disaster response, preparedness, and recovery efforts.',
      image: Department08,
      link: '/department/emergency',
    },
    {
      title: 'Department of Innovation and Technology',
      description: 'Leads digital transformation and enhances public service delivery through technology.',
      image: Department07,
      link: '/department/technology',
    },
  ];

  return (
    <section className="department-one-section">
      <div className="container">
        <div className="row row-gutter-30">
          {departments.map((dept, index) => (
            <div className="col-lg-6 col-xl-4" key={index}>
              <div className="department-two-card fixed-height">
                <div className="department-two-imgbox">
                  <div className="department-two-img">
                    <img src={dept.image} className="img-fluid" alt={dept.title} />
                    <Link to={dept.link} />
                  </div>
                  <div className="department-two-img-icon">
                    <Link to={dept.link}>
                      <i className="fa-solid fa-arrow-right-long" />
                    </Link>
                  </div>
                </div>
                <div className="department-two-content">
                  <h4>
                    <Link to={dept.link}>{dept.title}</Link>
                  </h4>
                  <p>{dept.description}</p>
                  <div className="department-two-button">
                    <Link to={dept.link}>
                      <i className="fa-solid fa-arrow-right-long" />
                      <span>Read More</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Departments;
